var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature3Icon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56391 22.2517C4.37523 20.7074 3.7809 19.9353 3.7809 17.6425C3.7809 15.3497 4.37523 14.5776 5.56391 13.0333C7.93736 9.94976 11.9179 6.45398 17.7665 6.45398C23.6151 6.45398 27.5956 9.94976 29.9691 13.0333C31.1577 14.5776 31.7521 15.3497 31.7521 17.6425C31.7521 19.9353 31.1577 20.7074 29.9691 22.2517C27.5956 25.3351 23.6151 28.8309 17.7665 28.8309C11.9179 28.8309 7.93736 25.3351 5.56391 22.2517Z",
    stroke: "black",
    strokeWidth: 2.09784
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9612 17.6426C21.9612 19.9599 20.0828 21.8383 17.7655 21.8383C15.4483 21.8383 13.5699 19.9599 13.5699 17.6426C13.5699 15.3253 15.4483 13.4469 17.7655 13.4469C20.0828 13.4469 21.9612 15.3253 21.9612 17.6426Z",
    stroke: "black",
    strokeWidth: 2.09784
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3Icon2);
export default __webpack_public_path__ + "static/media/feature3-icon-2.222624d12c4420b6528d82fb628c7c28.svg";
export { ForwardRef as ReactComponent };